import classnames from 'classnames';
import { noop } from 'lodash';
import { bool, string, object } from 'prop-types';
import React from 'react';

import Loader from 'Elements/Loader';
import { EMPTY_OBJ } from 'Services/constants/empty';
import styles from './styles.scss';

const IMAGE_CANCEL_SRC = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAB' +
'CAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

const minWaitTime = 1000;

class Image extends React.Component {
  static propTypes = {
    isContain: bool,
    src: string,
    classes: object,
  };
  static defaultProps = {
    isContain: true,
    src: IMAGE_CANCEL_SRC,
    classes: EMPTY_OBJ,
  };
  constructor(props) {
    super(props);
    this.state = {
      isErrored: false,
      isLoaded: false,
      src: IMAGE_CANCEL_SRC,
    };
  }
  componentDidMount() {
    this.handleImageLoad(this.props.src);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.setState({
        isLoaded: false,
      }, () => {
        this.handleImageLoad(this.props.src);
      });
    }
  }
  componentWillUnmount() {
    if (!this.img) {
      return;
    }
    this.img.onload = noop;
    delete this.img;
  }
  handleImageErrored = () => {
    this.setState({
      isErrored: true,
      isLoaded: true,
      src: IMAGE_CANCEL_SRC,
    });
  }
  handleImageLoad = (src) => {
    this.setState({
      loadTimeStart: Date.now(),
    });
    this.img = new window.Image();
    this.img.src = src;
    this.img.onload = this.handleImageLoaded;
    this.img.onerror = this.handleImageErrored;
  }
  handleImageLoaded = () => {
    const {
      loadTimeStart,
    } = this.state;
    const now = Date.now();
    // wait a minimum of 1 second when src changes
    if (now - loadTimeStart < minWaitTime) {
      window.setTimeout(() => {
        this.setState({
          isLoaded: true,
          src: this.props.src,
        });
      }, minWaitTime - (now - loadTimeStart));
    } else {
      this.setState({
        isLoaded: true,
        src: this.props.src,
      });
    }
  }
  render() {
    const {
      isContain,
      classes,
    } = this.props;
    const { src, isLoaded } = this.state;
    return (
      <div
        className={classnames(styles.imageContainer, classes.root)}
      >
        <div
          className={classnames(styles.image, isLoaded && styles.imageLoaded, isContain && styles.imageContain)}
          style={{ backgroundImage: `url(${src})` }}
        />
        { !isLoaded && (
          <Loader />
        )}
      </div>
    );
  }
}

export default Image;
